module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "messages"
    }
  }, [_c('header', [_c('a', {
    staticClass: "back",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack($event)
      }
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Neue Nachricht")])]), _vm._v(" "), _c('user-select', {
    attrs: {
      "placeholder": "Nachricht senden an",
      "type": "friends"
    },
    on: {
      "select": function($event) {
        _vm.$refs.message.focus()
      }
    },
    model: {
      value: (_vm.partner),
      callback: function($$v) {
        _vm.partner = $$v
      },
      expression: "partner"
    }
  }), _vm._v(" "), _c('ul'), _vm._v(" "), _c('form', {
    attrs: {
      "id": "send-message"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.send()
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    ref: "message",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "submit",
      "value": "Senden"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-488fc0d8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/conversation-new.vue
// module id = 224
// module chunks = 0